import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const PageHeader = ({
  icon,
  title,
  subtitle,
  description,
  backgroundImage,
  stats,
  children,
  className = ""
}) => {
  return (
    <section className={`relative py-16 bg-gradient-to-br from-slate-900 via-slate-800 to-orange-900 overflow-hidden ${className}`}>
      {backgroundImage && (
        <div className="absolute inset-0 opacity-20">
          <img
            src={backgroundImage}
            alt={title}
            className="w-full h-full object-cover"
          />
        </div>
      )}
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center text-white"
        >
          {icon && (
            <SafeIcon icon={icon} className="text-4xl text-orange-400 mb-6 mx-auto" />
          )}
          
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            {title}
          </h1>
          
          {subtitle && (
            <p className="text-xl text-slate-300 max-w-3xl mx-auto mb-8">
              {subtitle}
            </p>
          )}
          
          {description && (
            <p className="text-lg text-slate-200 max-w-4xl mx-auto mb-8 leading-relaxed">
              {description}
            </p>
          )}
          
          {stats && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-2xl mx-auto mb-8">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-3xl font-bold text-orange-400">{stat.value}</div>
                  <div className="text-slate-300 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          )}
          
          {children}
        </motion.div>
      </div>
    </section>
  );
};

export default PageHeader;